import { render, staticRenderFns } from "./forgot-password-box.vue?vue&type=template&id=10323104&"
import script from "./forgot-password-box.vue?vue&type=script&lang=js&"
export * from "./forgot-password-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports